
<template>
  <v-app id="searchIndd">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Layout details</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(inddRecord,i) in searchIndd" :key="i">
           <tr @click="$router.reload('/syst/ref/indd/onIndd/' + inddRecord.indd_encrid)">
             <td>{{inddRecord.indd_nr}}</td>
             <td>{{inddRecord.inddtaal_oms}}</td>
             <td>{{inddRecord.inddtaal_nl_oms}}</td>
             <td>{{inddRecord.inddtaal_de_oms}}</td>
             <td>{{inddRecord.inddtaal_fr_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchIndd: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/indd/searchIndd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchIndd"
          },
          searchIndd: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchIndd = res.data.searchIndd;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
